import React from "react";
import MeteredItemsPage from "../components/MeteredItemsPage";

function Photos() {
    return (
        <MeteredItemsPage itemFilter={(item) => !item.img_path} newDateRetries={3} />
    );
}

export default Photos;
